import * as React from 'react';
import { Button, Row, Col } from 'antd';
import { Link } from 'react-router-dom';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import TimeString from './timestring';

interface ProductProviderListViewProps extends ComponentViewProps<DataSet<ProductProviderItem>> {
	onItemDoubleClicked?: (item: ProductProviderItem) => any;
	initializeData: (productProviderApiName: string) => Promise<void>;
}

export class ProductProviderListView extends React.Component<ProductProviderListViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	public render() {
		const model = this.props.model;
		const columns = [
			{
				key: 'name',
				title: 'Name',
				dataIndex: 'name',
				render: (text, record: ProductProviderItem) => <Link to={`/products/product-providers/${record.id}`}>{text}</Link>,
			},
			{
				key: 'count',
				title: 'Max request count',
				dataIndex: 'requestLimits'
			},
			{
				key: 'isActiveForAccommodation',
				title: 'Accommodation',
				dataIndex: 'isActiveForAccommodation',
				render: (text, record: ProductProviderItem, index) => {
					return (
						<Row>
							<Col span={12}>
								<BooleanView label={null} mode='display' value={record.isActiveForAccommodation} />
							</Col>
							<Col span={12}>
								{record.isActiveForAccommodation && <TimeString time={record.cacheTimeForAccommodation} />}
							</Col>
						</Row>
					);
				}
			},
			{
				key: 'isActiveForGeneral',
				title: 'General',
				dataIndex: 'isActiveForGeneral',
				render: (text, record: ProductProviderItem, index) => {
					return (
						<Row>
							<Col span={12}>
								<BooleanView label={null} mode='display' value={record.isActiveForGeneral} />
							</Col>
							<Col span={12}>
								{record.isActiveForGeneral && <TimeString time={record.cacheTimeForGeneral} />}
							</Col>
						</Row>
					);
				}
			},
			{
				key: 'isActiveForTransfer',
				title: 'Transfer',
				dataIndex: 'isActiveForTransfer',
				render: (text, record: ProductProviderItem, index) => {
					return (
						<Row>
							<Col span={12}>
								<BooleanView label={null} mode='display' value={record.isActiveForTransfer} />
							</Col>
							<Col span={12}>
								{record.isActiveForTransfer && <TimeString time={record.cacheTimeForTransfer} />}
							</Col>
						</Row>
					);
				}
			},
			{
				key: 'isActiveForFlight',
				title: 'Flight',
				dataIndex: 'isActiveForFlight',
				render: (text, record: ProductProviderItem, index) => {
					const a = new Date()
					return (
						<Row>
							<Col span={12}>
								<BooleanView label={null} mode='display' value={record.isActiveForFlight} />
							</Col>
							<Col span={12}>
								{record.isActiveForFlight && <TimeString time={record.cacheTimeForFlight} />}
							</Col>
						</Row>
					);
				}
			},
			{
				key: 'isActiveForCarRent',
				title: 'Car Rent',
				dataIndex: 'isActiveForCarRent',
				render: (text, record: ProductProviderItem, index) => {
					return (
						<Row>
							<Col span={12}>
								<BooleanView label={null} mode='display' value={record.isActiveForCarRent} />
							</Col>
							<Col span={12}>
								{record.isActiveForCarRent && <TimeString time={record.cacheTimeForCarRent} />}
							</Col>
						</Row>
					);
				}
			},
			{
				key: 'isActiveForTour',
				title: 'Tour',
				dataIndex: 'isActiveForTour',
				render: (text, record: ProductProviderItem, index) => {
					return (
						<Row>
							<Col span={12}>
								<BooleanView label={null} mode='display' value={record.isActiveForTour} />
							</Col>
							<Col span={12}>
								{record.isActiveForTour && <TimeString time={record.cacheTimeForTour} />}
							</Col>
						</Row>
					);
				}
			},
			{
				key: 'command',
				title: '',
				dataIndex: 'apiName',
				render: (text, record: ProductProviderItem, index) => {
					if (record.canInitializeData) {
						return <Button onClick={() => this.props.initializeData(text)}>Initialize</Button>;
					}
					return null;
				}
			},
		];

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						hideToolbar={ToolbarVisibility.hideModifyButtons}
						itemDoubleClick={(item) => {
							if (this.props.onItemDoubleClicked) {
								this.props.onItemDoubleClicked(item);
							}
						}}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/product-providers/list/product-provider-list.view.tsx